import * as React from 'react'

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost'

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant
}

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-button-red text-titulo-hero hover:bg-red-700',
  secondary: 'bg-button-bg text-gray-900 hover:bg-button-bg-300',
  outline: 'border border-button-bg/40 hover:bg-gray-100',
  ghost: 'bg-transparent hover:bg-button-bg-100',
}

export function buttonClassName(
  variant: ButtonVariant = 'primary',
  className = '',
) {
  return `inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium transition ${variants[variant]} ${className}`
}

export function Button({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {

  return (
    <button className={buttonClassName(variant, className)} {...props}>
      {children}
    </button>
  )
}
